export default __webpack_public_path__ + "images/JL.20f93c3.png";